var _rect, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.919922,
    width: 31.2898,
    height: 31.2898,
    rx: 4.28627,
    fill: "#006838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4837,
    cy: 7.33136,
    r: 2.98224,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6525,
    cy: 16.577,
    r: 2.98224,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7881,
    cy: 7.33136,
    r: 2.98224,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4837,
    cy: 25.9412,
    r: 2.98224,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7877 13.5952C18.4346 13.5954 19.7691 14.9308 19.7692 16.5776C19.7691 17.2073 19.5741 17.791 19.2408 18.272C18.7028 19.0484 18.2076 20.009 18.2076 20.9536C18.2078 22.1089 18.8414 23.4131 19.4 24.4243C19.6351 24.85 19.7691 25.3397 19.7692 25.8608C19.769 27.5076 18.4344 28.843 16.7877 28.8433C15.1408 28.8432 13.8055 27.5077 13.8053 25.8608C13.8053 25.3497 13.934 24.8687 14.1608 24.4487C14.7126 23.4273 15.3452 22.1146 15.3453 20.9536C15.3453 20.7565 15.3542 20.5629 15.3717 20.3765C15.4297 19.756 15.1259 19.1286 14.6842 18.689C14.2092 18.2163 13.5118 17.889 12.8463 17.9673C12.6184 17.9942 12.3795 18.0093 12.1344 18.0093C11.07 18.0092 9.9365 18.5745 9.02698 19.1274C8.57691 19.401 8.04859 19.5591 7.48303 19.5591C5.83626 19.559 4.50097 18.2243 4.50061 16.5776C4.50061 14.9306 5.83604 13.5953 7.48303 13.5952C8.0485 13.5952 8.57692 13.7523 9.02698 14.0259C9.93642 14.5789 11.07 15.146 12.1344 15.146C13.1993 15.146 14.3336 14.5788 15.2438 14.0259C15.694 13.7524 16.2224 13.5952 16.7877 13.5952Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLogo);
export default __webpack_public_path__ + "static/media/CollapseLogo.a8f9a177f386c1ff30eebf91f2dcaa4d.svg";
export { ForwardRef as ReactComponent };